import type { ISweeprOtcPayload } from "@pages/Home/type/ISweeprOtcPayload";

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

const readString = (record: Record<string, unknown>, keys: string[]) => {
    const foundKey = keys.find((key) => typeof record[key] === "string");

    return foundKey ? (record[foundKey] as string) : undefined;
};

const readBoolean = (record: Record<string, unknown>, keys: string[]) => {
    const foundKey = keys.find((key) => typeof record[key] === "boolean");

    return foundKey !== undefined ? (record[foundKey] as boolean) : undefined;
};

const readStringArray = (record: Record<string, unknown>, keys: string[]) => {
    const foundKey = keys.find((key) => Array.isArray(record[key]));

    if (!foundKey) {
        return undefined;
    }

    const value = record[foundKey];

    return Array.isArray(value) && value.every((item) => typeof item === "string") ? (value as string[]) : undefined;
};

const mapSweeprOtcRecord = (record: Record<string, unknown>): ISweeprOtcPayload | undefined => {
    const accountnumber = readString(record, ["accountnumber", "accountNumber"]);
    const onetimecode = readString(record, ["onetimecode", "oneTimeCode", "onetimeCode"]);
    const isR6 = readBoolean(record, ["isR6"]);
    const isION = readBoolean(record, ["isION"]);
    const ionServices = readStringArray(record, ["ionServices"]);

    if (!accountnumber || !onetimecode || isR6 === undefined || isION === undefined || !ionServices) {
        return undefined;
    }

    return {
        accountnumber,
        onetimecode,
        isR6,
        isION,
        ionServices,
    };
};

export const mapSweeprOtcResponse = (response: unknown): ISweeprOtcPayload | undefined => {
    if (!isRecord(response)) {
        return undefined;
    }

    if (isRecord(response.data)) {
        return mapSweeprOtcRecord(response.data);
    }

    return mapSweeprOtcRecord(response);
};
